import React from "react";

const SvgComponent = props => (
  <svg
    viewBox="0 0 59.97 59.97"
    width="8em"
    height="8em"
    style={{ margin: "0 0 2em" }}
    {...props}
  >
    <path
      className="disc"
      d="M59.75 29.99a29.76 29.76 0 1 1-59.53 0 29.76 29.76 0 0 1 59.53 0"
      fill="#87465b"
    />
    <path d="M33.66 30.62l-6.13-3.54v7.08z" fill="#fff" />
    <path
      d="M41.2 29.99a11.2 11.2 0 1 1-22.42 0 11.2 11.2 0 0 1 22.41 0z"
      fill="none"
      stroke="#fff"
      strokeWidth={0.5}
    />
  </svg>
);

export default SvgComponent;



// WEBPACK FOOTER //
// ./images/bouton-capsule.svg